import { Button, Col, Modal, Row, Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";

function ApproveUserModal(props) {
  const positionState = useSelector((state) => state.positionState.value);

  return (
    <Modal
      title={"Approve user"}
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={props.handleCancel}
      footer={null}
    >
      <Row>
        <Col span={12} className="mb-6">
          <div className="text-xs">First name</div>
          <div>{props.data?.data?.firstName}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Last name</div>
          <div>{props.data?.data?.lastName}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Username</div>
          <div>{props.data?.data?.username}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Email</div>
          <div>{props.data?.data?.email}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Designation</div>
          <div>{props.data?.data?.designation}</div>
        </Col>
        <Col span={12} className="mb-6">
          <div className="text-xs">Unit</div>
          <div>{props.data?.data?.unitName}</div>
        </Col>

        <Col span={12} className="mb-6">
          <div className="text-xs">Status</div>
          <Tag color={"green"} className="uppercase">
            {props.data?.data?.status}
          </Tag>
        </Col>
        <Col span={12}>
          <div className="text-xs">Contact no</div>
          <div>{props.data?.data?.phone}</div>
        </Col>
        <Col span={12}>
          <div className="text-xs">Address</div>
          <div>{props.data?.data?.city}</div>
        </Col>
      </Row>
      {positionState?.userRole?.name !== "Manager"
        ? props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleReject}>
                Reject
              </Button>
              <Button type="primary" htmlType="submit" onClick={props.handleOk}>
                Approve
              </Button>
            </div>
          )
        : props.data?.status === "Pending" && (
            <div className="mt-6 flex justify-end">
              <Button danger className="mr-3" onClick={props.handleDelete}>
                Delete
              </Button>
            </div>
          )}
    </Modal>
  );
}

export default ApproveUserModal;
